module.exports = __webpack_public_path__ + "static/media/illuminate-1.97baba66.png";